module.exports = __webpack_public_path__ + "assets/b87.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b87.png
// module id = 679
// module chunks = 0